import React, { useContext, useEffect } from 'react';
import GeneralContext from '../../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import logo from '../../../assets/SMYO_logo-31.png'
import { Spin } from 'antd';
import { displayMessage } from '../../../services/helper';

const SplashScreen = () => {

    const {
        setLoggedUser, setUser, windowWidth, windowHeight,
    } = useContext(GeneralContext)

    useEffect(() => {
        setTimeout(handleOnValidateSession, 1000);
    })

    const handleOnValidateSession = async () => {
        try {
            const token = localStorage.getItem('token')
            const currentUser_id = JSON.parse(localStorage.getItem('user'))?.id

            if (!token) {
                setLoggedUser(false)
                return
            }

            await api.auth.setAuthorizationToken(token)
            const rs = await api.patient.get(currentUser_id)
            setUser(rs.data)
            setLoggedUser(true)
        } catch (error) {
            console.log(`${displayMessage('ERROR_VALIDATION_SECTION')}: `, error)
            setLoggedUser(false)
        }
    }

    return (
        <div style={{ width: windowWidth, height: windowHeight, gap: 20, backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <div style={{ maxHeight: 350, maxWidth: 350, margin: 20 }}>
                <img
                    src={logo}
                />
            </div>
            <Spin size="default" />
            <span>{displayMessage('DEVELOPED_BY')} <span className='font-bold'> Solve Light</span> </span>
        </div>
    );
};

export default SplashScreen;